import React from 'react';
import I18n from 'i18n-js';
import FormPrimaryActionButton from './form_primary_action_button';
import Location from '../lib/wrapped_location';
import QueryParamsUtil from '../reverb-js-common/query_params_util';

export default function OnboardingFormSaveButton({ isSaving, isDisabled, ...props }: any) {
  const disabled = isSaving || isDisabled;
  const redirect = QueryParamsUtil.getParamValue('redirect_to', Location.href);
  const saveButtonText = redirect ? I18n.t('discovery.coreOnboarding.saveAndContinue') : I18n.t('discovery.coreOnboarding.save');

  const buttonText = isSaving ? // show 'save' when disabled
    I18n.t('discovery.coreOnboarding.processing') :
    saveButtonText;

  return (
    <FormPrimaryActionButton
      disabled={disabled}
      buttonText={buttonText}
      {...props}
    />
  );
}
